export const dates = {
  detailed: {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  },
  short: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  short_time: {
    hour: 'numeric',
    minute: 'numeric'
  },
  long: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric'
  }
}

export const numbers = {
  currency: {
    style: 'currency', currency: 'RON'
  },
  empty: {
    style: 'decimal', minimumFractionDigits: 2
  },
  eur: {
    style: 'currency', currency: 'EUR'
  },
  usd: {
    style: 'currency', currency: 'USD'
  },
  ron: {
    style: 'currency', currency: 'RON'
  }
}

export const i18nFormatForNumbers: { [key: string]: string } = {
  style: 'decimal',
  minimumFractionDigits: '2',
  locale: 'ro'
}

export const i18nFormatForNumbersAlt: { [key: string]: string } = {
  style: 'decimal',
  minimumFractionDigits: '2',
  maximumFractionDigits: '2',
  locale: 'ro'
}
